import {useEffect, useState} from 'react'
import {FileDownloadModalHeader} from './FileDownloadModalHeader'
import {FileDownload} from './FileDownload'

const FileDownloadModal = ({fileURL, closeFileModal}) => {
  const [fileName, setFileName] = useState('')
  useEffect(() => {
    document.body.classList.add('modal-open')
    const filenameValue = fileURL.split('/').pop()
    setFileName((preVal) => (preVal = filenameValue))
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <FileDownloadModalHeader closeFileModal={closeFileModal} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <FileDownload fileURL={fileURL} fileName={fileName} closeFileModal={closeFileModal} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {FileDownloadModal}
